import { render } from "./CourseAddEdit.vue?vue&type=template&id=51e24724"
import script from "./CourseAddEdit.vue?vue&type=script&lang=js"
export * from "./CourseAddEdit.vue?vue&type=script&lang=js"

import "./CourseAddEdit.vue?vue&type=style&index=0&id=51e24724&lang=scss"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__